import * as React from "react"
import PropTypes from "prop-types"

const Header = ({ greetings }) => {
  return (
    <div className="container">
      <div className="hero">
        <h1 className="name">
          <strong>RYAN</strong>BEKHEN
        </h1>
        <span className="job-title">Software Engineer</span>
        <span className="email">i@ryanbekhen.dev</span>
        <h2 className="lead">{greetings}</h2>
      </div>
    </div>
  )
}

Header.propTypes = {
  greetings: PropTypes.string,
}

Header.defaultProps = {
  greetings: ``,
}

export default Header
